<template>
  <Layout>
    <desc_section :desc="desc"></desc_section>
<!--    123-->
<!--    <vue2-org-tree :data="data" :horizontal="horizontal" :collapsable="collapsable" :label-class-name="labelClassName"-->
<!--                   :render-content="renderContent" selected-class-name="bg-tomato" selected-key="selectedKey"-->
<!--                   @on-expand="onExpand" @on-node-click="onNodeClick">-->
<!--    </vue2-org-tree>-->
  </Layout>
</template>

<script>
import desc_section from "@/view/shop/dashboard/desc_section";
import Layout from "@/components/layouts/SimpleLayout";
// import Vue2OrgTree from "vue2-org-tree";

export default {
  components: {
    desc_section,
    Layout,
    // Vue2OrgTree,
  },
  name: "index",
  data() {
    return {
      // data: {
      //   id: 0,
      //   label: '新模式商城',
      //   children: [{
      //     id: 2,
      //     label: '第一个用户',
      //     children: [{
      //       id: 5,
      //       label: '第四个用户'
      //     }, {
      //       id: 6,
      //       label: '第五个用户'
      //     }, {
      //       id: 9,
      //       label: '第9个用户'
      //     }, {
      //       id: 10,
      //       label: '第八个用户'
      //     }]
      //   }, {
      //     id: 3,
      //     label: '第x个用户',
      //     children: [{
      //       id: 7,
      //       label: '第x个用户'
      //     }, {
      //       id: 8,
      //       label: '第x个用户'
      //     }]
      //   }, {
      //     id: 4,
      //     label: '第x个用户'
      //   }, {
      //     id: 9,
      //     label: '第x个用户'
      //   }]
      // },
      // expandAll: false,
      // horizontal: false,
      // collapsable: true,
      tips: "",
      desc: {
        wait_send: 0,
        wait_service: 0,
        goods_stock_warning: 0,
        wait_cash: 0,
        yesterday_paid_order: 0,
        yesterday_paid_order_statistics: 0,
        yesterday_money: 0,
        yesterday_money_statistics: 0,
        today_added_member: 0,
        today_added_member_statistics: 0,
        this_month_added_member: 0,
        this_month_added_member_statistics: 0,
      }
    }
  },
  /*methods:{*/
  /*  labelClassName: function() {*/
  /*    return 'clickable-node'*/
  /*  },*/
  /*  renderContent: function(h, data) {*/
  /*    return data.label*/
  /*  },*/
  /*  onExpand: function(e, data) {*/
  /*    if ('expand' in data) {*/
  /*      data.expand = !data.expand*/

  /*      if (!data.expand && data.children) {*/
  /*        this.collapse(data.children)*/
  /*      }*/
  /*    } else {*/
  //       this.$set(data, 'expand', true)
  //     }
  //   },
  //   onNodeClick: function(e, data) {
  //     console.log('onNodeClick: %o', data)
  //     this.$set(data, 'selectedKey', !data.selectedKey)
  //   },
  //   collapse: function(list) {
  //     var _this = this
  //     list.forEach(function(child) {
  //       if (child.expand) {
  //         child.expand = false
  //       }
  //
  //       child.children && _this.collapse(child.children)
  //     })
  //   },
  //   expandChange: function() {
  //     this.toggleExpand(this.data, this.expandAll)
  //   },
  //   toggleExpand: function(data, val) {
  //     var _this = this
  //     if (Array.isArray(data)) {
  //       data.forEach(function(item){
  //         _this.$set(item, 'expand', val)
  //         if (item.children) {
  //           _this.toggleExpand(item.children, val)
  //         }
  //       })
  //     } else {
  //       this.$set(data, 'expand', val)
  //       if (data.children) {
  //         _this.toggleExpand(data.children, val)
  //       }
  //     }
  //   }
  // },
  mounted() {
    this.$u.api.shop.desc().then(res => {
      this.desc = res;
    })
  }
}
</script>
<style>
.el-card__header {
  padding: 0 1rem;
  line-height: 2.6rem;
  font-size: .9rem;
}

/*.org-tree-container{display:inline-block;padding:15px;background-color:#fff}.org-tree{display:table;text-align:center}.org-tree:after,.org-tree:before{content:"";display:table}.org-tree:after{clear:both}.org-tree-node,.org-tree-node-children{position:relative;margin:0;padding:0;list-style-type:none}.org-tree-node-children:after,.org-tree-node-children:before,.org-tree-node:after,.org-tree-node:before{transition:all .35s}.org-tree-node-label{position:relative;display:inline-block}.org-tree-node-label .org-tree-node-label-inner{padding:10px 15px;text-align:center;border-radius:3px;box-shadow:0 1px 5px rgba(0,0,0,.15)}.org-tree-node-btn{position:absolute;top:100%;left:50%;width:20px;height:20px;z-index:10;margin-left:-11px;margin-top:9px;background-color:#fff;border:1px solid #ccc;border-radius:50%;box-shadow:0 0 2px rgba(0,0,0,.15);cursor:pointer;transition:all .35s ease}.org-tree-node-btn:hover{background-color:#e7e8e9;-webkit-transform:scale(1.15);transform:scale(1.15)}.org-tree-node-btn:after,.org-tree-node-btn:before{content:"";position:absolute}.org-tree-node-btn:before{top:50%;left:4px;right:4px;height:0;border-top:1px solid #ccc}.org-tree-node-btn:after{top:4px;left:50%;bottom:4px;width:0;border-left:1px solid #ccc}.org-tree-node-btn.expanded:after{border:none}.org-tree-node{padding-top:20px;display:table-cell;vertical-align:top}.org-tree-node.collapsed,.org-tree-node.is-leaf{padding-left:10px;padding-right:10px}.org-tree-node:after,.org-tree-node:before{content:"";position:absolute;top:0;left:0;width:50%;height:19px}.org-tree-node:after{left:50%;border-left:1px solid #ddd}.org-tree-node:not(:first-child):before,.org-tree-node:not(:last-child):after{border-top:1px solid #ddd}.collapsable .org-tree-node.collapsed{padding-bottom:30px}.collapsable .org-tree-node.collapsed .org-tree-node-label:after{content:"";position:absolute;top:100%;left:0;width:50%;height:20px;border-right:1px solid #ddd}.org-tree>.org-tree-node{padding-top:0}.org-tree>.org-tree-node:after{border-left:0}.org-tree-node-children{padding-top:20px;display:table}.org-tree-node-children:before{content:"";position:absolute;top:0;left:50%;width:0;height:20px;border-left:1px solid #ddd}.org-tree-node-children:after{content:"";display:table;clear:both}.horizontal .org-tree-node{display:table-cell;float:none;padding-top:0;padding-left:20px}.horizontal .org-tree-node.collapsed,.horizontal .org-tree-node.is-leaf{padding-top:10px;padding-bottom:10px}.horizontal .org-tree-node:after,.horizontal .org-tree-node:before{width:19px;height:50%}.horizontal .org-tree-node:after{top:50%;left:0;border-left:0}.horizontal .org-tree-node:only-child:before{top:1px;border-bottom:1px solid #ddd}.horizontal .org-tree-node:not(:first-child):before,.horizontal .org-tree-node:not(:last-child):after{border-top:0;border-left:1px solid #ddd}.horizontal .org-tree-node:not(:only-child):after{border-top:1px solid #ddd}.horizontal .org-tree-node .org-tree-node-inner{display:table}.horizontal .org-tree-node-label{display:table-cell;vertical-align:middle}.horizontal.collapsable .org-tree-node.collapsed{padding-right:30px}.horizontal.collapsable .org-tree-node.collapsed .org-tree-node-label:after{top:0;left:100%;width:20px;height:50%;border-right:0;border-bottom:1px solid #ddd}.horizontal .org-tree-node-btn{top:50%;left:100%;margin-top:-11px;margin-left:9px}.horizontal>.org-tree-node:only-child:before{border-bottom:0}.horizontal .org-tree-node-children{display:table-cell;padding-top:0;padding-left:20px}.horizontal .org-tree-node-children:before{top:50%;left:0;width:20px;height:0;border-left:0;border-top:1px solid #ddd}.horizontal .org-tree-node-children:after{display:none}.horizontal .org-tree-node-children>.org-tree-node{display:block}*/
/*# sourceMappingURL=style.css.map */
</style>
<style scoped>

</style>